<!-- 
  * @Author: zql
  * @Date: 2025/1/2 16:45
 -->

<template>
    <div class="batch">
        <div class="header">
            <el-button class="" size="mini" :loading="loading" type="primary" @click="handleRecognitionClick">识别剪切板</el-button>
            <el-link class="font12px ml20" type="primary" @click="openTemplate">点击(查看/使用)模板</el-link>
            <span class="font12px ml20 text-color-gray">按照模板填写内容后进行复制，复制后在此处点击【识别剪贴板】</span>
        </div>
        <el-table
            stripe
            :data="tableData"
            :header-cell-style="{ background: '#e8eaec', color: '#333' }"
            max-height="600px"
        >
            <el-table-column
                type="index"
                label="序号"
                width="50"/>
            <el-table-column
                width="180"
                :prop="item.name"
                v-for="(item, index) in column"
                :key="index">
                >
                <template slot="header">
                    {{item.display_name}}
                    <el-tooltip v-if="item.name === 'customer_id'"  effect="dark" content="多个客户可用中、英文逗号分隔" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row[item.name]}}</span>
                </template>

            </el-table-column>
        </el-table>
        <div class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">立即导入</el-button>
        </div>

        <el-dialog
            title="校验失败"
            :visible.sync="errDialog"
            :closeOnClickModal="false"
            :closeOnPressEscape="false"
            width="800px"
            append-to-body
            :before-close="hideErrDialog">
            <div class="con-wrap pl20 pr20" style="max-height: 250px;overflow-y: auto;">
                <ol style="list-style: disc" class="text-color-primary">
                    <li class="err-item mb10" v-for="(item,index) in errData" :key="item.info+index">
                        <p class="text-color-normal font12px">{{item.info}}</p>
                        <ol style="list-style: circle" class="text-color-primary ml10">
                            <li class="err-item">
                                <p class=" text-color-normal font12px">序号：{{(item.ids||[]).join('、')}}</p>
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
            <div slot="footer" class="dialog-footer tac">
                <el-button type="primary" @click="hideErrDialog">已知晓</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getClipboard } from '@/utils';
    import API from '@/api/dataCenter/appKpi.js';
    export default {
        name: "batchImportModal",
        props:['platId','config','cbs'],
        data() {
            return {
                tableData: [],
                loading: false,
                baseColumn:[
                    {
                        "name": "plat_name",
                        "display_name": "媒体"
                    },
                    {
                        "name": "app_name",
                        "display_name": "推广名称",
                        alwaysShow:true,
                    },
                    {
                        "name": "app_id",
                        "display_name": "推广ID",
                        alwaysShow:true,
                    },
                    {
                        "name": "package_name",
                        "display_name": "推广内容",
                        alwaysShow:true,
                    },
                    {
                        "name": "delivery_scene",
                        "display_name": "kpi维度（场景）",
                        alwaysShow:true,
                    },
                    {
                        "name": "subpackage_type",
                        "display_name": "分包类型",
                        alwaysShow:true,
                    },
                    {
                        "name": "budget",
                        "display_name": "每日预算",
                        alwaysShow:true,
                    },
                    {
                        "name": "register_price",
                        "display_name": "注册成本"
                    },
                    {
                        "name": "new_cost_price",
                        "display_name": "新增付费成本"
                    },
                    {
                        "name": "new_cost_rate",
                        "display_name": "新增付费率"
                    },
                    {
                        "name": "pay_roi1",
                        "display_name": "首日内购ROI"
                    },
                    {
                        "name": "active_price",
                        "display_name": "激活成本"
                    },
                    {
                        "name": "ad_monetization_roi_1",
                        "display_name": "首日变现ROI"
                    },
                    {
                        "name": "cli_price",
                        "display_name": "点击成本"
                    },
                    {
                        "name": "download_price",
                        "display_name": "下载成本"
                    },
                    {
                        "name": "pay_retention1_rate",
                        "display_name": "次日留存率"
                    },
                    {
                        "name": "pay_retention3_rate",
                        "display_name": "3日留存率"
                    },
                    {
                        "name": "pay_retention7_rate",
                        "display_name": "7日留存率"
                    },
                    {
                        "name": "pay_retention14_rate",
                        "display_name": "14日留存率"
                    },
                    {
                        "name": "pay_retention30_rate",
                        "display_name": "30日留存率"
                    },
                    {
                        "name": "pay_roi3",
                        "display_name": "3日内购ROI"
                    },
                    {
                        "name": "pay_roi7",
                        "display_name": "7日内购ROI"
                    },
                    {
                        "name": "pay_roi30",
                        "display_name": "30日内购ROI"
                    },
                    {
                        "name": "pay_roi",
                        "display_name": "当日内购ROI"
                    },
                    {
                        "name": "pay_ltv1",
                        "display_name": "首日内购LTV"
                    },
                    {
                        "name": "pay_ltv3",
                        "display_name": "3日内购LTV"
                    },
                    {
                        "name": "pay_ltv7",
                        "display_name": "7日内购LTV"
                    },
                    {
                        "name": "pay_ltv30",
                        "display_name": "30日内购LTV"
                    },
                    {
                        "name": "week_pay_roi",
                        "display_name": "自然周累计内购ROI"
                    },
                    {
                        "name": "month_pay_roi",
                        "display_name": "自然月累计内购ROI"
                    },
                    {
                        "name": "ad_monetization_roi_3",
                        "display_name": "3日变现ROI"
                    },
                    {
                        "name": "ad_monetization_roi_7",
                        "display_name": "7日变现ROI"
                    },
                    {
                        "name": "ad_monetization_roi_30",
                        "display_name": "30日变现ROI"
                    },
                    {
                        "name": "ad_monetization_roi_now",
                        "display_name": "当日变现ROI"
                    },
                    {
                        "name": "ad_monetization_ltv_1",
                        "display_name": "首日变现LTV"
                    },
                    {
                        "name": "ad_monetization_ltv_3",
                        "display_name": "3日变现LTV"
                    },
                    {
                        "name": "ad_monetization_ltv_7",
                        "display_name": "7日变现LTV"
                    },
                    {
                        "name": "ad_monetization_ltv_30",
                        "display_name": "30日变现LTV"
                    },
                    {
                        "name": "nature_week_sum_monetize_roi",
                        "display_name": "自然周累计变现ROI"
                    },
                    {
                        "name": "nature_month_sum_monetize_roi",
                        "display_name": "自然月累计变现ROI"
                    },
                    {
                        "name": "pay_income_roi1",
                        "display_name": "首日内购+变现ROI"
                    },
                    {
                        "name": "pay_income_roi3",
                        "display_name": "3日内购+变现ROI"
                    },
                    {
                        "name": "pay_income_roi7",
                        "display_name": "7日内购+变现ROI"
                    },
                    {
                        "name": "pay_income_roi30",
                        "display_name": "30日内购+变现ROI"
                    },
                    {
                        "name": "pay_income_roi",
                        "display_name": "当日内购+变现ROI"
                    },
                ],
                submitLoading:false,
                errDialog:false,
                errData:[],
                deliverySceneMap:{
                    "整体":'1',
                    "商店-整体":'2',
                    "非商店-整体":'3',
                    "信息流":'4',
                    "联盟":'5',
                    "智能投放":'6',
                },
                subpackageTypeMap:{
                    "分包":'1',
                    "联运包":'2',
                    "官包":'3',
                    "未分配":'0',
                },
            }
        },
        computed: {
            column(){
                return this.baseColumn.filter(col=>{
                    if(col.name=='plat_name') return false;
                    if(col.alwaysShow) return true;
                    return this.tableData.some(row=>!!row[col.name]);
                });
            }
        },
        methods: {
            handleClose(){
                this.$emit('close');
            },
            getPlatId(name) {
                let platList = [{id:1,name:'OPPO'},{id:3,name:'vivo'},{id:7,name:'小米'}]
                return platList.find(item=>item.name.toLocaleLowerCase()==name.toLocaleLowerCase())?.id;
            },
            handleSubmit() {
                if(this.tableData.length<=0) return this.$message.error('暂无数据，请通过模板导入KPI数据');

                this.submitLoading = true;
                let tableData = this.tableData.map(item=>{
                    let data = {...item};
                    data.delivery_scene = this.deliverySceneMap[data.delivery_scene]||data.delivery_scene;
                    data.subpackage_type = this.subpackageTypeMap[data.subpackage_type]||data.subpackage_type;
                    data.plat_id = this.getPlatId(data.plat_name)
                    delete data.plat_name;
                    return data;
                });
                API.checkBatchImport({
                    plat_id:this.platId,
                    data:tableData,
                }).then(res=>{
                    console.log('checkBatchImport',res);
                    this.hideErrDialog();
                    this.submitLoading = false;
                    this.doBatchImport({
                        plat_id:this.platId,
                        data:tableData,
                    });
                }).catch(err=>{
                    console.log('checkBatchImport err',err);
                    this.submitLoading = false;
                    let errData = err.data||{};
                    let errList = errData.err_list||[];
                    let isSetList = errData.isset||[];
                    if(Array.isArray(errList)&&errList.length>0){
                        this.errData = errList;
                        this.errDialog = true;
                    }else if(Array.isArray(isSetList)&&isSetList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p class="font12px text-color-error">以下产品对应场景的KPI已维护，确认要覆盖吗?</p>';
                        htmlStr += '<p class="font12px text-color-error">注意<span class="el-icon-warning text-color-warn"></span>：仅覆盖本次导入有值的KPI指标</p>';
                        htmlStr += '<p class="font12px">序号：'+(isSetList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '覆盖提醒', {
                            confirmButtonText: '覆盖',
                            cancelButtonText: '取消',
                            dangerouslyUseHTMLString: true,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(() => {
                            this.doBatchImport({
                                plat_id:this.platId,
                                data:tableData,
                            });
                        }).catch(() => {
                        });
                    }else{
                        this.$message.error(err.info||'请求异常');
                    }
                });
            },
            doBatchImport(data){
                if(this.submitLoading) return false;
                this.submitLoading = true;
                API.batchImport(data).then(res1=>{
                    this.submitLoading = false;
                    this.$message.success(res1.info||'请求成功');
                    console.log('batchImport',res1);
                    this.cbs.onSubmit();
                    this.handleClose();
                }).catch(err1=>{
                    this.submitLoading = false;
                    this.$message.error(err1.info||'请求异常');
                })
            },
            hideErrDialog(){
                this.errData = [];
                this.errDialog = false;
            },
            async handleRecognitionClick() {
                try {
                    this.loading = true;
                    const text = await getClipboard();
                    const list = text.split('\n').map(v=> {
                        let current_table_keys = this.baseColumn.map(item=>item.name);
                        console.log('v',v.split('\t'));
                        return v.split('\t').reduce((pre, item, index)=> {
                            if(current_table_keys.length >= index) {
                                let cur_key = current_table_keys[index]
                                pre[cur_key] = item.replace(/\r/g, '')
                            }else{
                                // pre[`${col_}${index+1}`] = item.replace(/\r/g, '')
                            }
                            return pre;
                        }, {})
                    }).filter(v=> {
                        return !!Object.values(v).join('')
                    });
                    if (list.length) {
                        this.tableData = list;
                        this.$message.success('识别成功')
                    }else {
                        this.$message.error('未获取到剪贴板内容或获取的内容为空，请重新复制')
                    }
                } catch (error) {
                    this.$message.error(error.message)
                } finally {
                    this.loading = false
                }
            },
            openTemplate() {
                let docUrl = 'https://ho734vnlan.feishu.cn/sheets/X2FIsSJiDheRm0td4hWcPS8tnrb';
                if(this.platId=='1'){
                    docUrl = 'https://ho734vnlan.feishu.cn/sheets/X2FIsSJiDheRm0td4hWcPS8tnrb';
                }else if(this.platId=='3'){
                    docUrl = 'https://ho734vnlan.feishu.cn/sheets/Iy17sUbNkhWwVHtWBsmcgWpSnBc';
                }else if(this.platId=='7'){
                    docUrl = 'https://ho734vnlan.feishu.cn/sheets/FpmXsL9mhhuMvAtDmp7cpPexnpd';
                }
                window.open(docUrl);
            },
        }
    }
</script>

<style lang="scss" scoped>

    .header {
        position: relative;
        top: -15px;
    }
</style>
